import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const Header = () => {
    const { t, i18n } = useTranslation();
    const [language, setLanguage] = useState(i18n.language);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setLanguage(lng);
    };

    return (
        <header
            className="bg-[#0a3891] text-[#fff] px-6 md:px-20 py-8 w-full"
            style={{ position: 'relative' }}
        >
            {/* Logo with dot styling */}
            <div className="text-3xl font-bold mb-10 text-left">
               <h1> Prodyt </h1>
            </div>
            
            {/* Title and Description - Added as per the image */}
            <div className="text-left mb-8">
                <h1 className="text-2xl md:text-3xl font-semibold mb-4">{t('register_product')}</h1>
                <p className="text-base">{t('registration_thank_you_message')}</p>
            </div>
            
            {/* Language Selector - Maintained from your original code but positioned absolutely */}
            <div className="absolute top-6 right-6">
    <select
        value={language}
        onChange={(e) => changeLanguage(e.target.value)}
        className="bg-white bg-opacity-90 border-2 border-yellow-400 text-[#424553] font-medium p-2 pl-3 pr-8 rounded-full shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer appearance-none focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
        style={{
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23F7941D'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E\")",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "right 0.75rem center",
            backgroundSize: "1.2em 1.2em"
        }}
    >
        <option value="en">English</option>
        {/* <option value="pt">Português</option> */}
        <option value="hi">हिंदी</option>
    </select>
</div>
        </header>
    );
};

export default Header;